import { EFinancingProgram } from '@if/core/types'
import { getApiClient } from '@src/services/api-client'
import { useQuery } from '@tanstack/react-query'
import { AvailableCredit } from '../types'

const SCOPE = 'availableCredit'
const DETAIL = 'detail'

export const availableCreditKeys = {
  all: [SCOPE] as const,
  byApplicationId: (financingProgramId: EFinancingProgram, creditApplicationId: string) =>
    [SCOPE, DETAIL, financingProgramId, creditApplicationId] as const,
}

// GET OPERATION
const getAvailableCredit = async (financingProgramId: EFinancingProgram, creditApplicationId: string) => {
  const apiClient = getApiClient()
  const url = `/Applications/${financingProgramId}/${creditApplicationId}/availablecredit`
  const response = await apiClient.get<AvailableCredit>(url)
  return response.data
}

export function useGetAvailableCredit(
  financingProgramId: EFinancingProgram | undefined,
  creditApplicationId: string | undefined,
): [AvailableCredit | undefined, boolean] {
  const { data, isFetching } = useQuery({
    queryKey: availableCreditKeys.byApplicationId(
      financingProgramId ?? ('' as EFinancingProgram),
      creditApplicationId ?? '',
    ),
    queryFn: () => getAvailableCredit(financingProgramId!, creditApplicationId!),
    enabled: !!financingProgramId && !!creditApplicationId,
  })

  return [data, isFetching]
}
